
import { useEffect, useState } from 'react';
import { registerServiceWorker } from '@/lib/sw-register';
import { UpdatePrompt } from '@/components/ui';
import { logger } from '@/lib/logger';

interface PWAProviderProps {
  children: React.ReactNode;
}

/**
 * PWA Provider component that handles:
 * - Service worker registration
 * - Update prompts
 */
export function PWAProvider({ children }: PWAProviderProps) {
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    const initPWA = async () => {
      try {
        const { registration, error } = await registerServiceWorker();
        if (error) {
          logger.error('[PWA] Service worker registration failed:', error);
        } else if (registration) {
          logger.info('[PWA] Service worker registered');
        }
        setIsReady(true);
      } catch (error) {
        logger.error('[PWA] Initialization error:', error);
        setIsReady(true);
      }
    };
    initPWA();
  }, []);

  return (
    <>
      {children}
      <UpdatePrompt />
    </>
  );
}

export default PWAProvider;
